import PropTypes from "prop-types";
import { Button, Typography } from "@material-ui/core";
import ListAltIcon from "@mui/icons-material/ListAlt";

export default function MonitoramentoPrecoHeader({ classes, onMinhasColetas }) {
  return (
    <header className={classes.topBar}>
      <div className={classes.titleBlock}>
        <Typography component="h1" className={classes.titleMain}>
          Monitoramento de Preços – Loja Física
        </Typography>
        <p className={classes.subtitle}>
          Registre os preços dos produtos Karsten e dos concorrentes encontrados
          na loja.
        </p>
      </div>
      <Button
        variant="outlined"
        color="primary"
        className={classes.minhasColetasBtn}
        startIcon={<ListAltIcon />}
        onClick={onMinhasColetas}
      >
        Minhas coletas
      </Button>
    </header>
  );
}

MonitoramentoPrecoHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  onMinhasColetas: PropTypes.func.isRequired,
};
